import { createFormHook, createFormHookContexts } from "@tanstack/react-form";

import { FormCheckbox } from "./form.checkbox";
import { FormComboboxTagInput } from "./form.combobox-tag-input";
import { FormDateRangeField } from "./form.date-range-field";
import { FormInputGroupInput } from "./form.input-group";
import { FormLabelGroup } from "./form.label-group";
import { FormRadioGroup } from "./form.radio-group";
import { FormRoot } from "./form.root";
import { FormSelect } from "./form.select";
import { FormSubscribeButton } from "./form.submit-button";
import { FormSwitch } from "./form.switch";
import { FormTabs } from "./form.tabs";
import { FormTagInput } from "./form.tag-input";
import { FormTextField } from "./form.text-field";
import { FormTextarea } from "./form.textarea";
import { FormToggle } from "./form.toggle";
import { FormToggleGroup, FormToggleGroupMultiple } from "./form.toggle-group";

const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField: FormTextField,
    Textarea: FormTextarea,
    Select: FormSelect,
    Checkbox: FormCheckbox,
    RadioGroup: FormRadioGroup,
    Switch: FormSwitch,
    Tabs: FormTabs,
    LabelGroup: FormLabelGroup,
    Toggle: FormToggle,
    ToggleGroup: FormToggleGroup,
    ToggleGroupMultiple: FormToggleGroupMultiple,
    InputGroupInput: FormInputGroupInput,
    TagInput: FormTagInput,
    ComboboxTagInput: FormComboboxTagInput,
    DateRangeField: FormDateRangeField,
  },
  formComponents: {
    Root: FormRoot,
    SubscribeButton: FormSubscribeButton,
  },
});

export {
  fieldContext,
  formContext,
  useAppForm,
  useFieldContext,
  useFormContext,
  withFieldGroup,
  withForm,
};
